import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-left-2-icon',
  templateUrl: './navigation-left-2.component.html'
})
export class NavigationLeft2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
